var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSewerBackup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sewer-backup",
    fill: "none",
    viewBox: "0 0 46 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.81 16h7.42",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.81 27.7h24.38",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1.27 27.7h4.24",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1.27 16h4.24",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40.49 27.7h4.24",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m40.49 16h4.24",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m27.77 16h7.42",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.23 6.6401v10.495c0 0.38 0.2148 0.7301 0.5611 0.8866 2.8468 1.2865 4.8739 1.1719 8.3211-0.0303 0.3958-0.138 0.6578-0.5145 0.6578-0.9337v-10.417",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m15.05 5.64v-3.265c0-0.55228 0.4477-1 1-1h14.43c0.5523 0 1 0.44772 1 1v3.265c0 0.55228-0.4477 1-1 1h-14.43c-0.5523 0-1-0.44772-1-1z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m9.2802 30.625h-2.77c-0.55228 0-1-0.4477-1-1v-16.135c0-0.5523 0.44772-1 1-1h2.77c0.55229 0 1 0.4477 1 1v16.135c0 0.5523-0.44776 1-1 1z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m38.96 30.625h-2.77c-0.5522 0-1-0.4477-1-1v-16.135c0-0.5523 0.4478-1 1-1h2.77c0.5523 0 1 0.4477 1 1v16.135c0 0.5523-0.4477 1-1 1z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewerBackup);
export default __webpack_public_path__ + "static/media/sewer-backup.bfb3cac4b93747fe9c45d1188a0c08ac.svg";
export { ForwardRef as ReactComponent };